<h3 class="m-3">
  <span class="icon-text">
    <mat-icon color="primary" svgIcon="total-info"></mat-icon>
    <span>{{data.title}}</span>
  </span>
</h3>

<mat-dialog-content class="pt-0">
  @if (data.text) {
  <p>{{data.text}} : </p>
  }


  <ul>
    @for (item of data.list; track $index) {
    <li>{{item}}</li>
    }
  </ul>

</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close cdkFocusInitial>{{'messages.label.ok' | translate}}</button>
</mat-dialog-actions>